import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { UserService } from '../user/user.service';
import { AuthService } from './auth.service';
import { Permission } from './permissions';
import { UserTypes } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private router: Router,
  ) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<boolean> {
    if (!this.auth.isAuthenticated) {
      this.router.navigate(['/login']);
      return false;
    }

    const user = await this.userService.profile();
    const requiredPermissions: Permission[] = next.data.permissions;
    const allowedRoles: string[] = next.data.userTypes || [UserTypes.ADMIN];

    const hasPerms = await this.userService.hasPermissions(requiredPermissions);

    if (!hasPerms) {
      this.router.navigate(['/']);
    }

    if (user.type === UserTypes.ADMIN) {
      return hasPerms;
    }

    // If the route has role restrictions, check if user role is allowed
    if (allowedRoles.length && !allowedRoles.includes(user.type)) {
      this.router.navigate(['/404']);
      return false;
    }
  }
}
